<template>
  <span class="status-tag" :class="`status-${tone}`">
    <i></i>{{ label }}
  </span>
</template>

<script>
const labels = {
  accepted: '已受理',
  sending: '等待回调',
  connected: '已接通',
  not_connected: '未接通',
  failed: '失败',
  cancelled: '已取消',
  success: '成功',
  unreachable: '不可达',
  rejected_by_user: '用户拒接',
  callback_timeout: '回调超时',
  pending: '待发布',
  retry: '等待重试',
  processing: '发布中',
  published: '已发布',
  unmatched: '未匹配',
  not_checked: '未检测',
  healthy: '正常'
}

export default {
  name: 'StatusTag',
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    label () {
      return labels[this.status] || this.status || '未知'
    },
    tone () {
      if (['connected', 'success', 'healthy', 'published'].includes(this.status)) return 'success'
      if (['sending', 'accepted', 'not_checked', 'pending', 'retry', 'processing'].includes(this.status)) return 'pending'
      if (['failed', 'not_connected', 'unreachable', 'rejected_by_user', 'unmatched', 'callback_timeout'].includes(this.status)) return 'danger'
      if (this.status === 'cancelled') return 'muted'
      return 'neutral'
    }
  }
}
</script>
